var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentPortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.287 509.287",
    style: {
      enableBackground: "new 0 0 509.287 509.287"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBD303"
    },
    cx: 254.644,
    cy: 254.644,
    r: 254.644
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74594E"
    },
    d: "M426.215,354.331v-27.126c0-25.77-22.04-46.792-49.166-46.792H132.238 c-27.126,0-49.166,21.022-49.166,46.792v27.126H426.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0BA7A"
    },
    d: "M304.487,322.119c-22.379,37.976-77.648,37.976-100.026,0c0-21.701,0-43.74,0-65.441 c33.229,0,66.797,0,100.026,0C304.487,278.379,304.487,300.419,304.487,322.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F3F7"
    },
    d: "M438.082,359.417c-3.052-12.885-13.224-23.057-26.787-27.465l-93.584-28.143l-23.057,21.362 l-80.36,0.339l-25.77-21.701l-90.532,28.143c-13.563,4.408-23.396,14.919-26.787,27.465l-13.902,55.947 c46.453,57.303,117.658,93.923,197.34,93.923s150.887-36.62,197.679-93.923L438.082,359.417z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#393D47"
    },
    cx: 253.287,
    cy: 139.359,
    r: 125.457
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CFA2"
    },
    d: "M298.045,91.211c-35.603,74.257-121.049,65.102-146.819,60.355v38.993 c0,56.286,45.775,102.061,102.061,102.061s102.061-45.775,102.061-102.061v-46.453C308.217,140.376,298.045,91.211,298.045,91.211z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#886C60"
    },
    d: "M116.98,468.599c11.528,7.46,24.074,14.241,36.959,19.666V311.947H116.98V468.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#886C60"
    },
    d: "M355.687,488.265c12.885-5.425,25.091-12.207,36.959-19.666V311.947h-36.959V488.265z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B5AA7"
    },
    d: "M263.46,325.849h-17.971l-24.074,28.821l19.666,28.482l-18.988,124.101 c10.511,1.356,21.362,2.034,32.551,2.034s22.04-0.678,32.551-2.034l-19.327-124.101l19.666-28.482L263.46,325.849z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCFCFD"
    },
    points: "204.8,284.143 253.287,325.849 214.294,383.152 188.524,303.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCFCFD"
    },
    points: "303.131,284.143 254.644,325.849 293.637,383.152 319.407,303.809  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPortrait);
export default __webpack_public_path__ + "static/media/student_portrait.09a288a67e97879f3fd786947f02cc84.svg";
export { ForwardRef as ReactComponent };